<template>
  <b-navbar toggleable="lg" type="dark" class="bg-orange" sticky>
    <div class="container" :style="isLoggedIn ? { width: '1370px', 'max-width': '100%' } : {}">
      <div class="nav-logo-primary mx-auto">
        <a href>
          <img src="../../assets/images/logo-white.png" alt="Dicicil Aja" />
        </a>
      </div>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" class="navbarText" is-nav>
        <span class="navbar-text mr-auto my-3 my-xl-0 nav-profile-primary section-welcome">{{
          who == 0 || getUserRole == "nasabah"
            ? "Selamat Datang"
            : `Hai, ${getUser.nama}`
        }}</span>

        <!-- <b-navbar-nav class="ml-auto">
          <div v-for="(m, i) in menu" :key="i">
            <b-nav-item-dropdown
              v-if="m.child && (!m.role || getUserRole === m.role)"
              :text="m.title"
              right
            > -->
        <b-navbar-nav class="ml-auto">
          <div v-for="(m, i) in menu" :key="i">
            <b-nav-item-dropdown
              v-if="m.child && (!m.role || getUserRole === m.role)"
              right
            >
              <template #button-content>
                <span class="menu-title">{{ m.title }}</span>
                <span
                  v-if="m.title === 'AXI' && isMaxDateThreeMonthsLater()"
                  class="mini-label2 align-left rectangle-shape2"
                  >BARU</span
                >
              </template>

              <span v-for="(c, ic) in m.child" :key="ic">
                <b-dropdown-item
                  v-if="
                    c.route_name === 'download_report_ppd' &&
                    isMaxDateThreeMonthsLater()
                  "
                  :to="{ name: c.route_name, query: c.query }"
                >
                  <span class="mini-label rectangle-shape align-right"
                    >BARU</span
                  >
                  {{ c.title }}
                </b-dropdown-item>

                <b-dropdown-item
                  v-else-if="c.route_name"
                  :to="{ name: c.route_name, query: c.query }"
                  @click.native="sendAnalyticsDropdown(c)"
                  >{{ c.title }}</b-dropdown-item
                >

                <b-dropdown-item
                  v-else
                  :to="{
                    name: m.group_route_name,
                    params: { product: c.product_name },
                  }"
                  @click.native="sendAnalyticsDropdown(c)"
                  >{{ c.title }}</b-dropdown-item
                >
              </span>
            </b-nav-item-dropdown>

            <b-nav-item v-else :class="{ active: routeMatch(m.route_name) }">
              <router-link
                :to="{ name: m.route_name }"
                @click.native="sendAnalytics(m)"
                >{{ m.title }}</router-link
              >
            </b-nav-item>
          </div>

          <div class="d-block d-lg-none">
            <template v-if="!isLoggedIn">
              <b-nav-item>
                <router-link :to="{ name: 'login' }">Masuk</router-link>
              </b-nav-item>

              <!-- <b-nav-item>
                <router-link :to="{ name: 'register' }">Daftar</router-link>
              </b-nav-item>-->

              <b-nav-item-dropdown
                id="my-nav-dropdown"
                text="Daftar"
                toggle-class="nav-link-custom"
                right
              >
                <b-dropdown-item>
                  <router-link :to="{ name: 'register' }"
                    >Daftar Nasabah</router-link
                  >
                </b-dropdown-item>
                <b-dropdown-item>
                  <router-link :to="{ name: 'axi_register' }"
                    >Daftar AXI</router-link
                  >
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>

            <b-nav-item v-else>
              <a class="cursor-pointer" @click.prevent="confirmLogout"
                >Keluar</a
              >
            </b-nav-item>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </div>
    <logout-modal ref="logoutModal" :isSuccess="isLogoutSuccess" />

    <logout-confirmation-modal ref="logoutConfirmationModal" :logout="logout" />
  </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LogoutModal from "@/components/modals/LogoutModal";
import LogoutConfirmationModal from "@/components/modals/LogoutConfirmationModal";
import { pushDataLayer, headerMenu } from "../../plugins/analytics";
import { createHttpClient } from "@/helpers/httpFactory";
import { token } from "@/services/token";

export default {
  components: {
    LogoutModal,
    LogoutConfirmationModal,
  },
  data() {
    return {
      user: null,
      isLogoutSuccess: false,
      keyword: "",
    };
  },
  computed: {
    ...mapGetters({
      getUserRole: "auth/getUserRole",
      getUser: "auth/getUser",
      isLoggedIn: "auth/isLoggedIn",
    }),
    menu() {
      const { menu } = this.$store.state;

      // console.log(this.who);
      switch (this.who) {
        case 0:
          return menu.guest;
        // just comment break to fix issue unreachable code
        // break;
        case 1:
          return menu.sales_head;
        // just comment break to fix issue unreachable code
        // break;
        case 2:
          return menu.nasabah;
        case 3:
          return menu.super_admin;
        default:
          return menu.axi;
        // just comment break to fix issue unreachable code
        // break;
      }
    },
    who() {
      if (this.getUserRole == "axi") {
        return this.getUserRole;
      } else if (this.getUserRole == "sales head") {
        return 1;
      } else if (this.getUserRole == "nasabah") {
        return 2;
      } else if (this.getUserRole == "super admin") {
        return 3;
      } else {
        return 0;
      }
    },
  },
  methods: {
    isMaxDateThreeMonthsLater() {
      const maxDate = new Date(); // Get the maximum date
      maxDate.setMonth(maxDate.getMonth() + 3); // 3 months after
      const currentDate = new Date(); // Get the current date
      return currentDate <= maxDate; // Return true if current date is less than or equal to the maximum date
    },

    ...mapActions({
      logoutAction: "auth/logout",
      setKeyword: "product/setKeyword",
      checkAuth: "auth/checkAuth",
      refreshToken: "auth/refreshToken",
    }),
    sendAnalytics(route) {
      // Send Analytics 1
      pushDataLayer(headerMenu(route.title, this.$route.path));
    },
    sendAnalyticsDropdown(route) {
      // Send Analytics 2
      pushDataLayer(headerMenu("Product Pembiayaan", route.title));
    },
    routeMatch(nav_route) {
      return nav_route === this.$route.name;
    },
    search() {
      this.setKeyword(this.keyword);
      if (this.$route.name !== "search") {
        this.$router.push({ name: "search" });
      }
    },
    async logout() {
      try {
        await this.logoutAction();
        this.isLogoutSuccess = true;
        this.$refs.logoutConfirmationModal.show();
        this.$refs.logoutModal.show();
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } catch (err) {
        this.isLogoutSuccess = false;
        this.$refs.logoutConfirmationModal.show();
        this.$refs.logoutModal.show();
        // console.log(err);
      }
    },
    async confirmLogout() {
      this.$refs.logoutConfirmationModal.show();
    },
  },
};
</script>
<style scoped>
.mini-label {
  color: #ffffff;
  font-size: 12px;
}

.mini-label2 {
  /* color: #FFFFFF; */
  font-size: 10px;
  margin-left: 5px;
}

.align-right {
  float: right;
}

.rectangle-shape {
  display: inline-block;
  padding: 4px 8px;
  background-color: #3086bf;
  border-radius: 4px;
}

.rectangle-shape2 {
  display: inline-block;
  padding: 2px 4px;
  border: 1px solid;
  border-radius: 2px;
}
</style>
